// extracted by mini-css-extract-plugin
export default {"Menu":"Menu_Menu__2LQtB","option":"Menu_option__6KJc6","icon":"Menu_icon__zpgZN"};